import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { challenge as ChallengeGen } from '@valvur/shared-grpc';

@Component({
  selector: 'app-course-description',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './course-description.component.html',
  styleUrl: './course-description.component.scss',
})
export class CourseDescriptionComponent {
  course = input<ChallengeGen.Course | ChallengeGen.Task | null>(null);
  showTitle = input<boolean>(false);

  title = computed(() => {
    const c = this.course();
    if (!c) return '';
    return 'courseName' in c ? (c.courseName ?? '') : (c.title ?? c.name ?? '');
  });

  description = computed(() => {
    const c = this.course();
    if (!c) return '';
    return 'courseDescription' in c
      ? (c.courseDescription ?? '')
      : (c.description ?? '');
  });
}
